<button type="button" [style.width]="width" [style.height]="height" [style.margin]="margin" class="icon_button" (click)="onClick($event)">
    <ng-content></ng-content>
</button>